<template>
    <el-dialog :visible.sync="visible"
               :title="title"
               width="480px"
               :before-close="doCancel">
        <el-form label-position="inline"
                 ref="message-form"
                 :model="form"
                 @submit.native.prevent="doConfirm"
                 :rules="rules"
                 label-width="120px">
            <el-form-item label="手机号：">
                <h4>{{ contact | mobileEncrypt }}</h4>
            </el-form-item>
            <el-form-item label="短信验证码："
                          prop="pin">
                <el-input v-model="form.pin"
                          :maxlength="6"
                          placeholder="请输入短信验证码">
                    <timer-button slot="append"
                                  @click="doSendMessage"
                                  :time="60">发送验证码</timer-button>
                </el-input>
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button @click="doCancel">取 消</el-button>
            <el-button type="primary"
                       @click="doConfirm">确认签署</el-button>
        </div>
    </el-dialog>
</template>

<script>
import TimerButton from '../../../components/timer-button.vue';

export default {
    components: { TimerButton },
    props: {
        visible: Boolean,
        title: String,
        contact: String
    },
    data () {
        return {
            form: {
                pin: ''
            },
            rules: {
                pin: [
                    { required: true, message: '请输入短信验证码', triggle: 'blur' }
                ]
            }
        };
    },
    computed: {
        openApi () {
            return this.$store.getters.system.openApi;
        },
        // token 秘钥
        zwdt_access_token () {
            return this.$route.query.zwdt_access_token;
        },
        defaultParams () {
            return this.zwdt_access_token ? {
                zwdt_access_token: this.zwdt_access_token
            } : {};
        },
        defaultHeaders () {
            return this.zwdt_access_token ? {
                zwdt_access_token: this.zwdt_access_token
            } : {};
        },
    },
    filters: {
        mobileEncrypt (value) {
            return value ? value.substr(0, 3) + '****' + value.substr(7) : '';
        }
    },
    methods: {

        doCancel () {
            this.$refs['message-form'].resetFields();
            this.$emit('update:visible', false);
        },

        /**
         * 发送短信验证码
         */
        async doSendMessage () {
            let loading = this.$loading({
                text: '加载中...'
            });
            try {
                let resp = await this.axios.get(`/zwdt/view/mobile/pin`, {
                    params: Object.assign({}, this.defaultParams, { mobile: this.contact }),
                }, {
                    headers: this.defaultHeaders,
                });
                if (resp.data.code === 0) {
                    this.$message.success('成功发送验证码!');
                } else {
                    this.$message.error(resp.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        async doConfirm () {
            try {
                await this.$refs['message-form'].validate();
                this.$emit('onConfirm', this.form.pin);
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .el-button--default:hover {
    color: #2489F2 !important;
    border-color: #2489F2 !important;
    background: #ecf5ff !important;
}
</style>

